/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var general_pb = require('./general_pb.js')
const proto = {};
proto.cloud = require('./service_deletion_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceProjectDataDeletionClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceProjectDataDeletionPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.DeleteCommentsRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodDescriptor_ServiceProjectDataDeletion_DeleteComments = new grpc.web.MethodDescriptor(
  '/cloud.ServiceProjectDataDeletion/DeleteComments',
  grpc.web.MethodType.UNARY,
  proto.cloud.DeleteCommentsRequest,
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.DeleteCommentsRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodInfo_ServiceProjectDataDeletion_DeleteComments = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.DeleteCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.DeletionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.DeletionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceProjectDataDeletionClient.prototype.deleteComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteComments',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteComments,
      callback);
};


/**
 * @param {!proto.cloud.DeleteCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.DeletionResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceProjectDataDeletionPromiseClient.prototype.deleteComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteComments',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.DeleteDrivesRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodDescriptor_ServiceProjectDataDeletion_DeleteDrives = new grpc.web.MethodDescriptor(
  '/cloud.ServiceProjectDataDeletion/DeleteDrives',
  grpc.web.MethodType.UNARY,
  proto.cloud.DeleteDrivesRequest,
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteDrivesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.DeleteDrivesRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodInfo_ServiceProjectDataDeletion_DeleteDrives = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteDrivesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.DeleteDrivesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.DeletionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.DeletionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceProjectDataDeletionClient.prototype.deleteDrives =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteDrives',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteDrives,
      callback);
};


/**
 * @param {!proto.cloud.DeleteDrivesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.DeletionResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceProjectDataDeletionPromiseClient.prototype.deleteDrives =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteDrives',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteDrives);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.DeleteEntityRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodDescriptor_ServiceProjectDataDeletion_DeleteEntities = new grpc.web.MethodDescriptor(
  '/cloud.ServiceProjectDataDeletion/DeleteEntities',
  grpc.web.MethodType.UNARY,
  proto.cloud.DeleteEntityRequest,
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteEntityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.DeleteEntityRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodInfo_ServiceProjectDataDeletion_DeleteEntities = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteEntityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.DeleteEntityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.DeletionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.DeletionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceProjectDataDeletionClient.prototype.deleteEntities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteEntities',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteEntities,
      callback);
};


/**
 * @param {!proto.cloud.DeleteEntityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.DeletionResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceProjectDataDeletionPromiseClient.prototype.deleteEntities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteEntities',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteEntities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.DeleteJobRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodDescriptor_ServiceProjectDataDeletion_DeleteJobs = new grpc.web.MethodDescriptor(
  '/cloud.ServiceProjectDataDeletion/DeleteJobs',
  grpc.web.MethodType.UNARY,
  proto.cloud.DeleteJobRequest,
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.DeleteJobRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodInfo_ServiceProjectDataDeletion_DeleteJobs = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.DeleteJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.DeletionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.DeletionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceProjectDataDeletionClient.prototype.deleteJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteJobs',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteJobs,
      callback);
};


/**
 * @param {!proto.cloud.DeleteJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.DeletionResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceProjectDataDeletionPromiseClient.prototype.deleteJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteJobs',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteJobs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.DeleteVolumesRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodDescriptor_ServiceProjectDataDeletion_DeleteVolumes = new grpc.web.MethodDescriptor(
  '/cloud.ServiceProjectDataDeletion/DeleteVolumes',
  grpc.web.MethodType.UNARY,
  proto.cloud.DeleteVolumesRequest,
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteVolumesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.DeleteVolumesRequest,
 *   !proto.cloud.DeletionResponse>}
 */
const methodInfo_ServiceProjectDataDeletion_DeleteVolumes = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.DeletionResponse,
  /**
   * @param {!proto.cloud.DeleteVolumesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.DeletionResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.DeleteVolumesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.DeletionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.DeletionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceProjectDataDeletionClient.prototype.deleteVolumes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteVolumes',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteVolumes,
      callback);
};


/**
 * @param {!proto.cloud.DeleteVolumesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.DeletionResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceProjectDataDeletionPromiseClient.prototype.deleteVolumes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceProjectDataDeletion/DeleteVolumes',
      request,
      metadata || {},
      methodDescriptor_ServiceProjectDataDeletion_DeleteVolumes);
};


module.exports = proto.cloud;

